import { Box, Flex } from '@chakra-ui/react';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';
import { ChatMessage } from 'model/modules/chat/chatMessage';
import { FC } from 'react';
import ChatRoomThumbnail from 'presentation/components/modules/chat/ChatRoomThumbnail';
import chatEmployeeImage from 'assets/img/thumbnail/chat-employee.jpeg';
import ChatMessageBubble from './ChatMessageBubble';

interface Props extends ChatMessage {
  isPreviousMessageFromDifferentUser: boolean;
  isNextMessageFromDifferentUser: boolean;
  isSelfMessage: boolean;
  roomType: ChatRoomType;
  avatar: string | null;
  authorName: string | null | undefined;
}

const ChatMessageRow: FC<Props> = ({
  text,
  isNextMessageFromDifferentUser,
  avatar,
  isPreviousMessageFromDifferentUser,
  isSelfMessage,
  authorName,
  roomType,
  createdAt,
  status,
  files,
}) => {
  const showAuthorName = !isSelfMessage && isPreviousMessageFromDifferentUser;

  const showAvatar = isNextMessageFromDifferentUser && !isSelfMessage;

  const thumbnailSize = '40px';

  let bubble = (
    <ChatMessageBubble
      authorName={showAuthorName ? authorName ?? '' : undefined}
      text={text}
      isSelfMessage={isSelfMessage}
      files={files}
      createdAt={createdAt}
      status={status}
      showTrianglePolygon={isNextMessageFromDifferentUser}
    />
  );

  if (!isSelfMessage) {
    bubble = (
      <Flex alignItems="flex-end" maxW="100%" minW={0}>
        <Box mr="5px" flexShrink={0}>
          {showAvatar ? (
            <ChatRoomThumbnail
              avatar={avatar}
              roomType={roomType}
              name={authorName ?? null}
              size={thumbnailSize}
              fallbackAvatar={chatEmployeeImage}
            />
          ) : (
            <Box w={thumbnailSize} />
          )}
        </Box>
        {bubble}
      </Flex>
    );
  }

  return (
    <Flex
      pb={isNextMessageFromDifferentUser ? '20px' : '10px'}
      px="20px"
      alignItems={isSelfMessage ? 'flex-end' : 'flex-start'}
      flexDirection="column"
    >
      {bubble}
    </Flex>
  );
};

export default ChatMessageRow;
